import { ForwardedRef, forwardRef, memo, useCallback } from 'react';
import { RegistrationFieldProps } from '../../RegistrationField.types';
import { Box, Icon, Text, TextInput } from '@betty/moonlight';
import { Pressable } from 'react-native';
import { Modal } from '@betty/navigation';

function LimitsField(
  { placeholderKey, placeholderNS }: RegistrationFieldProps<'limits'>,
  _: ForwardedRef<TextInput>,
) {
  const onPress = useCallback(() => {
    Modal.open({
      namespace: 'auth',
      type: 'RegistrationLimitsModal',
      options: {
        hideHeader: false,
      },
      style: {
        width: {
          mobile: '100%',
          tablet: '100%',
          desktop: 550,
        },
        height: {
          mobile: '100%',
          tablet: '100%',
          desktop: 800,
        },
        paddingTop: 'space-200',
        backgroundColor: 'screenBackground',
      },
    });
  }, []);

  return (
    <Pressable onPress={onPress}>
      <Box
        position="relative"
        flexDirection="row"
        alignItems="center"
        borderTopWidth="border-width-050"
        borderBottomWidth="border-width-050"
        borderColor="borderPrimary"
        height="space-1400"
      >
        <Box flex={1} justifyContent="center">
          <Text
            variant="h6"
            color="darkSurfacePrimary"
            locNS={placeholderNS}
            locKey={placeholderKey}
          />
        </Box>
        <Box position="absolute" right="space-100">
          <Icon name="arrowForwardIosOutlined" color="darkSurfacePrimary" />
        </Box>
      </Box>
    </Pressable>
  );
}

export default memo(forwardRef(LimitsField));
